import * as SheetPrimitive from "@radix-ui/react-dialog"
import { SheetContent } from "./sheet-content"
import { SheetDescription } from "./sheet-description"
import { SheetHeader } from "./sheet-header"
import { SheetFooter } from "./sheet-footer"
import { SheetTitle } from "./sheet-title"
import { SheetOverlay } from "./sheet-overlay"

const Sheet = SheetPrimitive.Root
const SheetTrigger = SheetPrimitive.Trigger
const SheetClose = SheetPrimitive.Close
const SheetPortal = SheetPrimitive.Portal

export {
  Sheet,
  SheetTrigger,
  SheetClose,
  SheetContent,
  SheetDescription,
  SheetFooter,
  SheetHeader,
  SheetOverlay,
  SheetPortal,
  SheetTitle,
}